import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Card, Form, Button, notification} from 'antd'
import Request, {API_URL} from '../../../request'
import moment from 'moment'


@Form.create()

class ShowRaisedSuggestions extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    suggestions: [],
  }

  apiRequest = async() => {
    let params = {
      results: 1000,
      suggestionType: 'Raise Ticket'
    };
    let response = await Request.getAllSuggestions(params);
    this.setState({total: response.total, suggestions: response.data})
  }
  componentWillMount() {    
  }

  async componentDidMount() {
    await this.apiRequest();
  }
  
  completeTicket = async(id) => {
    let response = await Request.completeRaisedTickets({_id: id});
    if (!response.error) {
      await this.apiRequest();
      notification.success({
        message: 'Suggestion Accepted Successfully'
      })
    } else {
      notification.success({
        message: 'Error while updating'
      })
    }
  }

  render() {

    // const {
    //   form: {getFieldDecorator, setFieldsValue}
    // } = this.props
    const {suggestions, total} = this.state;
    return (
      <PageHeaderWrapper title={` Tickets: ${total} `}>
        <Card bordered={true}>
          <div className="leaderboard">
            <main className="leaderboard__profiles">
              {
                suggestions && suggestions.map((suggestion, index) => {
                  return(
                    <article key={index} className="leaderboard__profile">
                      <span className="leaderboard__name">{suggestion.title}</span>
                      <small><b>BY: </b>{suggestion.createdByUser.name} / {moment(suggestion.createdByUser.time).format('lll')}</small>
                      <p className="faq-desc" dangerouslySetInnerHTML={{__html: suggestion.description}}></p>
                      <p className="faq-desc"><b>Raised Ticket:</b> {suggestion.suggestionToken}</p>
                      <p className="faq-desc"><b>Status:</b> {suggestion.suggestionStatus}</p>
                      <p className="faq-desc">
                        {
                          suggestion.document && suggestion.document.length ? 
                          <a target={'_blank'} href={API_URL+suggestion.document[0].url}>View Document</a>
                          :null
                        }
                        {
                          suggestion.suggestionStatus === 'Pending' ?
                          <Button className='btn btn-raised-ticket ant-btn-primary' type='button' onClick={(e) => {this.completeTicket(suggestion._id)}}>Accept</Button>
                          :null
                        }                        
                      </p>
                    </article>
                  )
                })
              }
            </main>
          </div>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default ShowRaisedSuggestions
